import {
  mapPersonSettlementTourType,
  useFindPersonSettlementsSuspense,
} from '@api';
import { Route } from 'src/routes/_rootLayout/persons/$id.settlements';
import { PersonSettlementsTable } from './components';

export const PersonSettlements: React.FC = () => {
  const { id } = Route.useParams();
  const { data: settlements } = useFindPersonSettlementsSuspense(id, {
    query: {
      select: (response) => response.data.map(mapPersonSettlementTourType),
    },
  });

  return <PersonSettlementsTable settlements={settlements} />;
};
